import '../styles/pharmascope.scss';

import WebFont from 'webfontloader';

WebFont.load({
  google: {
    families: ['Montserrat:100,100italic,200,200italic,300,300italic,400,400italic,500,500italic,600,600italic,700,700italic,800,800italic,900,900italic'],
  },
});
